export class NoResultsController implements ng.IController {
    items: any[];
    isLoading: boolean;
    isGlobalSearchAllowed: boolean;
    isSearchAllRequestsButtonVisible: boolean;

    $onInit() { };

    get show(): boolean {
        return !this.hasItems() && !this.isLoading;
    }

    private hasItems(): boolean {
        if (!this.items)
            return false;

        return this.items.length > 0;
    }

    
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/directives/noResults/controllers/noResultsController.ts
 **/